import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './tab-panel.styles';

/**
 * @slot default - The component content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */

export class BlocksTabPanel extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * skipFocusOnPanel- setting this will remove focus on panel element
   */
  @property({ type: Boolean })
  skipFocusOnPanel = false;

  /**
   * Indicates if the panel is selected.
   * @attr selected
   */
  @property({ type: Boolean, reflect: true })
  public selected = false;

  protected firstUpdated(): void {
    this.setAttribute('role', 'tabpanel');
    if (!this.skipFocusOnPanel) {
      this.setAttribute('tabindex', '0');
    }
  }

  render(): TemplateResult<1> {
    const componentClassNames = this.componentClassNames('cat-c-tab-panel', {});

    return html`
      <div part="base" class="${componentClassNames}">
        <slot part="part-default"></slot>
      </div>
    `;
  }
}

if (customElements.get('cat-tab-panel') === undefined) {
  customElements.define('cat-tab-panel', BlocksTabPanel);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-tab-panel': BlocksTabPanel;
  }
}
